import React from 'react';
import QuoteGenerator from '../components/QuoteGenerator';

const Home: React.FC = () => {
    return (
        <div className="app-container">
            <h1>Happy Life AI</h1>
            <p>Deine tägliche Dosis Motivation!</p>
            <QuoteGenerator />
            <div className="announcement-box">
                <h2>Bald verfügbar...</h2>
                <p>Dein persönlicher Begleiter für Meditation, Atemübungen und inneres Wachstum. ♾️</p>
            </div>
        </div>
    );
};

export default Home;